// enum which contains the survey states
const DrawingQuestionType = Object.freeze({
  BLANK: 'BLANK',
  BODY: 'BODY',
  IMAGE: 'IMAGE'
});

export default DrawingQuestionType;
